import TokenService from '@/services/token.service';
import * as Sentry from '@sentry/vue';
import router from '@/router';
import { useSessionStore } from '@/stores/session.store';
import { useDomainsStore } from '@/stores/domains.store';
import { useProductsStore } from '@/stores/products.store';
import { useNotificationStore } from '@/stores/notification.store';
import { FilterStorageService, IdlesService } from '@/services';
import { STORAGE_KEYS } from '@/custom/menicon/constants';
import PusherService from '@/services/broadcasting/pusher.service';

const logoutService = async (revokeToken = true) => {
  const sessionStore = useSessionStore();

  // Flag the logout in progress so the API error handler suppresses
  // 401/403 notifications from any in-flight requests that fail because
  // the token is being revoked.
  sessionStore.isLoggingOut = true;

  // Clear all notifications immediately so stale "forbidden" messages are
  // not visible on the login page after the redirect.
  useNotificationStore().clearAllNotifications();

  try {
    if (revokeToken) {
      await sessionStore.revokeUserToken({
        token: sessionStore.refreshToken
      });
    }
  } catch (e) {
    console.warn('Unable to revoke user token');
  } finally {
    IdlesService.removeAll();
    TokenService.removeToken();
    FilterStorageService.remove([
      ...STORAGE_KEYS
    ]);
    sessionStore.setCurrentUser(null);
    window.localStorage.removeItem('organisationId');

    const domainsStore = useDomainsStore();
    domainsStore.invalidateCache();
    domainsStore.clearPendingRequests();

    const productsStore = useProductsStore();
    productsStore.invalidateCache();
    productsStore.clearPendingRequests();

    Sentry.configureScope((scope) => scope.setUser({}));
    (new PusherService()).disconnect();
    try {
      if (router.currentRoute.value.name !== 'login') {
        await router.push({ name: 'login' });
      }
    } finally {
      sessionStore.isLoggingOut = false;
    }
  }
};

export default logoutService;
